<template>
  <b-card>
    <span v-if='seen' :style="{marginBottom : '10px',fontSize : 'larger',fontWeight : '600'}">KEMAMPUAN</span>
    <hr v-if='seen' />
    <b-row class="blog-list-wrapper mt-1">
      <b-col
        v-for="data in optionsLocal.kemampuan"
        :key="data.id"
        md="12"
      >
        <b-card-text><h4>{{data.nama}}</h4></b-card-text>
        <div class="blog-list-wrapper mb-2">
          <span
            v-for="item in data.item"
            :key="item.id"
            md="5"
          >
            <b-button
              v-if="item.active"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mt-1 mr-1"
              @click="hapusKemampuan(item.id, item.kategori_jenis_tiket_id)"
            >
              <feather-icon icon="CheckIcon" />
              {{item.nama}}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mt-1 mr-1"
              @click="pilihKemampuan(item.id, item.kategori_jenis_tiket_id)"
            >
              {{item.nama}}
            </b-button>
          </span>
        </div>
      </b-col>
    </b-row>
    <br/>
    <span v-if='seenKemampuan' :style="{marginBottom : '10px',fontSize : 'larger',fontWeight : '600'}">KEMAMPUAN SEBAGAI USER</span>
    <hr v-if='seenKemampuan' />
    <b-row class="blog-list-wrapper mt-1">
      <b-col
        v-for="data in optionsLocalUser.kemampuan"
        :key="data.id"
        md="12"
      >
        <b-card-text><h4>{{data.nama}}</h4></b-card-text>
        <div class="blog-list-wrapper mb-2">
          <span
            v-for="item in data.item"
            :key="item.id"
            md="5"
          >
            <b-button
              v-if="item.active"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mt-1 mr-1"
              @click="hapusKemampuanUser(item.id, item.kategori_jenis_tiket_id)"
            >
              <feather-icon icon="CheckIcon" />
              {{item.nama}}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mt-1 mr-1"
              @click="pilihKemampuanUser(item.id, item.kategori_jenis_tiket_id)"
            >
              {{item.nama}}
            </b-button>
          </span>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import storeModule from '@/connection-api/user/storeModule'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      optionsLocal: {},
      optionsLocalUser: {},
      seenKemampuan: false,
      seen: false,
      userData: JSON.parse(localStorage.getItem('userData')),
      userId: null,
    }
  },
  unmounted() {
    const USER_APP_STORE_MODULE_NAME = 'pengguna'
    if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
  },
  async mounted() {
    if (this.$route.params.id) {
      this.userId = this.$route.params.id
    } else {
      this.userId = this.userData.id
    }
    this.reloadData()
    this.reloadDataUser()
  },
  methods: {
    reloadData() {
      const USER_APP_STORE_MODULE_NAME = 'pengguna'
      // Register module
      if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

      store.dispatch('pengguna/fetchDataKemampuan', { id: this.userId })
        .then(response => {
          this.optionsLocal = response.data.data
          this.seen = true
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.optionsLocal = {}
          }
        })
    },
    pilihKemampuan(jenisTiketId, kategorijenisTiketId) {
      const localdata = {
        user_id: this.userId,
        jenis_tiket_id: jenisTiketId,
        kategori_jenis_tiket_id: kategorijenisTiketId,
      }
      store.dispatch('pengguna/addDataKemampuan', localdata)
        .then(response => {
          this.reloadData()
        })
        .catch(error => {
          if (error.response.status === 404) {
            // console
          }
        })
    },
    pilihKemampuanUser(jenisTiketId, kategorijenisTiketId) {
      this.makeToast('danger', 'Data Tidak Bisa Di Pilih')
    },
    reloadDataUser() {
      const USER_APP_STORE_MODULE_NAME = 'pengguna'
      // Register module
      if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

      store.dispatch('pengguna/fetchDataKemampuanRoles', { id: this.userId })
        .then(response => {
          this.optionsLocalUser = response.data.data
          if (response.data.data.kemampuan.length > 0) {
            this.seenKemampuan = true
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.optionsLocalUser = {}
          }
        })
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Kemampuan',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    hapusKemampuanUser(jenisTiketId, kategorijenisTiketId) {
      this.makeToast('danger', 'Data Tidak Bisa Di Hapus')
    },

    hapusKemampuan(jenisTiketId, kategorijenisTiketId) {
      const localdata = {
        user_id: this.userId,
        jenis_tiket_id: jenisTiketId,
        kategori_jenis_tiket_id: kategorijenisTiketId,
      }
      store.dispatch('pengguna/removeDataKemampuan', localdata)
        .then(response => {
          this.reloadData()
        })
        .catch(error => {
          if (error.response.status === 404) {
            // console
          }
        })
    },
  },
  // beforeCreate() {
  //   // this.$http.get('/account-setting/data').then(res => { this.options = res.data })
  // },
}
</script>
